import { FormControl, FormGroup } from '@angular/forms';
import { PaginationParams, SortingParams, TabParams } from '@app/@data/filtering/filtering.interface';
import { InputOptionResource } from '@app/@feed-inputs';
import { LaravelBoolean } from '@app/@core/http/crud-model/laravel-boolean';

export interface FleetInvoicesFilterParams extends PaginationParams, SortingParams, TabParams {
  vin_reg_keyword: string;
  dispositions: InputOptionResource;
  fleets: string;
  invoices: string;
  cost_groups: string;
  statuses: string;
  issue_date_from: string;
  issue_date_to: string;
  paid_from: string;
  paid_to: string;
  sale_from: string;
  sale_to: string;
  invoice_number: string;
  hide_zeroed: LaravelBoolean;
}

export type FleetInvoiceFilterParamsFormGroup = FormGroup<{
  vin_reg_keyword: FormControl<string>;
  dispositions: FormControl<InputOptionResource>;
  fleets: FormControl<string[]>;
  invoices: FormControl<string>;
  cost_groups: FormControl<string[]>;
  statuses: FormControl<string>;
  issue_date_from: FormControl<string>;
  issue_date_to: FormControl<string>;
  paid_from: FormControl<string>;
  paid_to: FormControl<string>;
  sale_from: FormControl<string>;
  sale_to: FormControl<string>;
  invoice_number: FormControl<string>;
  hide_zeroed: FormControl<LaravelBoolean>;
}>;

export type FleetInvoiceSortSlug = 'asc' | 'desc';

export class FleetInvoiceSort {
  static readonly ASC: FleetInvoiceSortSlug = 'asc';
  static readonly DESC: FleetInvoiceSortSlug = 'desc';
}

export type FleetInvoiceTabSlug =
  | 'operating_invoice'
  | 'correction_operating_invoice'
  | 'external_invoice'
  | 'correction_external_invoice'
  | 'draft_correction_operating_invoice';

export class FleetInvoiceTab {
  static OPERATING_INVOICE: FleetInvoiceTabSlug = 'operating_invoice';
  static CORRECTION_OPERATING_INVOICE: FleetInvoiceTabSlug = 'correction_operating_invoice';
  static EXTERNAL_INVOICE: FleetInvoiceTabSlug = 'external_invoice';
  static CORRECTION_EXTERNAL_INVOICE: FleetInvoiceTabSlug = 'correction_external_invoice';
  static CORRECTIONS_SKETCH: FleetInvoiceTabSlug = 'draft_correction_operating_invoice';
}

export type FleetInvoicesFilterKey = 'fleet_invoices' | 'fleet_invoices_afl';
